import { CheckBadgeIcon } from '@heroicons/react/24/solid';
import Button from '../common/button.tsx';
import { useNavigate } from 'react-router-dom';
import { useSuspenseQuery } from '@apollo/client';
import { GET_TEST_ATTEMPT_SCORE_DATA } from '../../apollo/test-attempt.ts';
import { toast } from 'react-toastify';
import { cn } from '../../utils/common-utils.ts';
import { RoutesEnum } from '../../utils/enums.ts';
import { TestAttemptStatus } from '../../apollo/__generated__/graphql.ts';
import { useStartNewTest } from '../tests/tests-hooks.tsx';

interface IProps {
  testAttemptId: number;
  status?: TestAttemptStatus;
  continueTest?: () => void;
  closeModal?: () => void;
}

const AttemptFinish = ({
  testAttemptId,
  status,
  continueTest,
  closeModal,
}: IProps) => {
  const navigate = useNavigate();
  const { startNewTest } = useStartNewTest();
  const { data, refetch } = useSuspenseQuery(GET_TEST_ATTEMPT_SCORE_DATA, {
    variables: { input: { id: testAttemptId } },
    errorPolicy: 'all',
  });
  const attempt = data?.testAttempt?.getAttempt;
  const isSkippedAttempt = status === TestAttemptStatus.Skipped;

  const gotoHome = () => {
    if (closeModal) {
      closeModal();
    }
    navigate('/');
  };

  const gotoReport = (url: string | null | undefined) => {
    if (!url) {
      refetch().finally(() => {
        if (!url) {
          toast.warning(
            'The report has not yet been prepared, please try again in 30 seconds',
          );
          return;
        }
        window.open(url, '_blank');
      });
    } else window.open(url, '_blank');
  };

  // const viewAnswerReport = () => {
  //   if (closeModal) {
  //     closeModal();
  //   }
  //   gotoReport(attempt?.answerReportUrl);
  // };

  // const viewScoreReport = () => {
  //   if (closeModal) {
  //     closeModal();
  //   }
  //   gotoReport(attempt?.scoreReportUrl);
  // };

  const reviewTest = () => {
    if (closeModal) {
      closeModal();
    }
    gotoReport(`${import.meta.env.VITE_BASE_URL}/review-test/${testAttemptId}`);
  };

  return (
    <div className={'flex-center'}>
      <section
        className={cn(
          'w-2xl rounded-xl border border-table-border p-8',
          closeModal ? 'mt-4' : 'mt-40',
        )}
      >
        <div
          className={'flex flex-col items-center justify-center text-center'}
        >
          <h1>{isSkippedAttempt ? 'Attempt Skipped' : "You're All Finished!"}</h1>
          {!isSkippedAttempt && (
            <CheckBadgeIcon className="my-5 h-24 w-24 text-green" />
          )}
          {isSkippedAttempt ? (
            <p className={'mx-auto max-w-[42rem] text-center'}>
              This test attempt was skipped. Click &quot;Retake&quot; to take it
              again.
            </p>
          ) : (
            <>
              <p>Congratulations on completing your test.</p>
              <p>Your scores will be available shortly.</p>
            </>
          )}
        </div>

        <div className={'mt-6 grid w-[350px] grid-cols-1 gap-3'}>
          <Button onClick={gotoHome} white>
            Return home
          </Button>
          {isSkippedAttempt ? (
            attempt?.test?.id && (
              <Button onClick={() => startNewTest(attempt.test.id)}>
                Retake
              </Button>
            )
          ) : (
            <>
              <Button
                onClick={() => {
                  window.open(
                    `${import.meta.env.VITE_BASE_URL}${RoutesEnum.TEST_ATTEMPT_ATTEMPT_ID_ANSWER_REPORT.replace(':attemptId', `${testAttemptId}`)}`,
                    '_blank',
                  );
                }}
              >
                View Answer Report
              </Button>
              <Button onClick={reviewTest} white>
                Review Test
              </Button>
              <Button
                onClick={() => {
                  window.open(
                    `${import.meta.env.VITE_BASE_URL}${RoutesEnum.TEST_ATTEMPT_ATTEMPT_ID_SCORE_REPORT.replace(':attemptId', `${testAttemptId}`)}`,
                    '_blank',
                  );
                }}
              >
                View Score Report
              </Button>
            </>
          )}
          {!isSkippedAttempt && continueTest && (
            <Button onClick={continueTest} white>
              Retake with saved Answers
            </Button>
          )}
        </div>
      </section>
    </div>
  );
};
export default AttemptFinish;
